import { render, staticRenderFns } from "./ctrl-show-text.vue?vue&type=template&id=a12b9350&scoped=true"
import script from "./ctrl-show-text.vue?vue&type=script&lang=js"
export * from "./ctrl-show-text.vue?vue&type=script&lang=js"
import style0 from "./ctrl-show-text.vue?vue&type=style&index=0&id=a12b9350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12b9350",
  null
  
)

export default component.exports